import { useEffect } from "react";
import { siteConfig } from "@/context/SettingsContext";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Dynamic SEO: title, description, OG, Twitter, canonical and JSON-LD. */
export function useSeo({ title, description, image, type = "website", jsonLd } = {}) {
  useEffect(() => {
    const BRAND = siteConfig.name;
    const full = title ? `${title} — ${BRAND}` : siteConfig.seo?.title || `${BRAND} — O‘zbek filmlari onlayn`;
    const desc = (description || siteConfig.seo?.description || "Eng yaxshi o‘zbek filmlarini yuqori sifatda onlayn tomosha qiling.").slice(0, 300);
    const img = image || siteConfig.seo?.og_image || "";
    const url = window.location.origin + window.location.pathname + window.location.search;
    document.title = full;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", full);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", BRAND);
    if (img) upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", img ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", full);
    upsertMeta("name", "twitter:description", desc);
    if (img) upsertMeta("name", "twitter:image", img);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    const prev = document.getElementById("ld-json");
    if (prev) prev.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "ld-json";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, type, jsonLd]);
}
